import React, {useEffect} from 'react'
import formatNumber from '@i18n/formatNumber'
import usePreferences from '@page-components/CheckoutV3/hooks/usePreferences.main'
import useSections from '@page-components/CheckoutV3/hooks/useSections'
import {useTranslation} from 'next-i18next'

import CustomTip from '../CustomTip'
import Selector from '../Selector'
import useOnSubmitHandlers from '../useOnSubmitHandlers'

import useSetTipAmount from './useSetTipAmount'

const USES_NO_TIP = true

export default function FixedTip() {
  const {preferences} = usePreferences()
  const {cart} = preferences
  const {tipOptions: options, calculatedTipAmount} = cart
  const sections = useSections()
  const setTipAmount = useSetTipAmount()
  const {onSuccess, onError} = useOnSubmitHandlers()

  const {website} = preferences
  const noTipByDefault = website?.noTipByDefault
  const {t} = useTranslation('checkoutv3', {keyPrefix: 'payment.tip'})

  const tipOptions = USES_NO_TIP ? options : options?.filter(option => option > 0)

  useEffect(() => {
    if (noTipByDefault)
      setTipAmount({
        amount: 0,
        onSuccess: () => {},
        onError: () => {}
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!sections.includes('tip')) return null

  return (
    <div className="flex flex-row space-x-2 justify-center overflow-x-auto">
      {tipOptions.map((tip, id) => {
        if (USES_NO_TIP ? id > 3 : id > 2) return null

        return (
          <Selector
            key={`tip_${id}`}
            selected={tip === calculatedTipAmount}
            onClick={() => {
              if (tip === calculatedTipAmount) return
              setTipAmount({amount: tip, onError, onSuccess})
            }}
            top={tip === 0 ? t('noTip') : ''}
            bottom={tip === 0 ? '' : formatNumber(tip, 'money')}
          />
        )
      })}
      {USES_NO_TIP ? null : <CustomTip selected={!tipOptions.includes(calculatedTipAmount)} />}
    </div>
  )
}
